import React, { memo } from 'react';
import { Alert, Button } from '../../../../components';
import { Text } from '../../../../components';
import { makeNiceName, htmlEscape } from '../../../../lib/helpers';
import './CloudAttributesError.scss';

/**
 * Error panel shown when cloud attributes fail to load.
 */
export const CloudAttributesError = memo(({ error, onRetry }) => {
    const data = error?.data || {};
    const errorCode = data.error_code;
    const message = data.message || data.error_message || error?.message || 'Failed to load cloud attributes';
    const resolution = data.resolution;

    return (
        <Alert
            type="error"
            showIcon
            title="Failed to Load Cloud Attributes"
            description={
                <div className="cloud-attributes-error">
                    {errorCode && (
                        <div className="cloud-attributes-error__row">
                            <Text bold>Error Code:</Text> {makeNiceName(errorCode)}
                        </div>
                    )}
                    <div className="cloud-attributes-error__row">
                        <Text bold>Error Message:</Text>{' '}
                        <span dangerouslySetInnerHTML={{ __html: htmlEscape(message) }} />
                    </div>
                    {resolution && (
                        <div className="cloud-attributes-error__row">
                            <Text bold>Action:</Text> {resolution}
                        </div>
                    )}
                </div>
            }
            action={
                onRetry ? (
                    <Button size="small" onClick={onRetry}>
                        Retry
                    </Button>
                ) : null
            }
        />
    );
});

